export default __webpack_public_path__ + "static/media/black_point.f9dac370.png";